import clsx from "clsx";
import styles from "./styles.module.css";

function InnerLoader({position, height, marginTop}: {position?: string, height?: string, marginTop?: string}) {
  return (
    <div className={clsx(styles.loaderContainer, `${position}imp`)} style={{height: height, marginTop: marginTop}}>
      <div className={clsx(styles.loader)}>&nbsp;</div>
    </div>
  )
}
export default InnerLoader;